import { Component, Input, OnInit } from '@angular/core';
import { FeatureInfo } from './restricted-content';
import { map } from 'rxjs/operators';
import { SubscriptionTiersService } from '@galaxy/partner';
import { PartnerService } from '../../core/partner.service';
import { Observable } from 'rxjs';
import { getImageSrc } from '../../core/images';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AssignedSalespersonDialogComponent } from '../../assigned-salesperson/assigned-salesperson-dialog/assigned-salesperson-dialog.component';
import { AssignedSalespersonService } from '../../assigned-salesperson/assigned-salesperson.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCard, MatCardContent } from '@angular/material/card';

const materialComponents = [MatIconModule, MatButtonModule, MatDialogModule];

@Component({
  standalone: true,
  selector: 'app-restricted-content',
  templateUrl: './restricted-content.component.html',
  styleUrls: ['./restricted-content.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    ...materialComponents,
    TranslateModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatCard,
    MatCardContent,
  ],
})
export class RestrictedContentComponent implements OnInit {
  @Input() featureInfo: FeatureInfo;

  isFreeTier$: Observable<boolean>;
  featuredImage: string;
  dialogConfig$: Observable<MatDialogConfig<any>>;
  constructor(
    private partnerService: PartnerService,
    private readonly dialog: MatDialog,
    private assignedSalespersonService: AssignedSalespersonService,
  ) {}

  ngOnInit(): void {
    this.isFreeTier$ = this.partnerService.subscriptionTier$.pipe(map((s) => SubscriptionTiersService.isFree(s)));
    this.featuredImage = getImageSrc(this.featureInfo.image);
    this.dialogConfig$ = this.assignedSalespersonService.dialogConfig$;
  }

  openSalespersonDialog(dialogConfig: MatDialogConfig): void {
    this.dialog.open(AssignedSalespersonDialogComponent, dialogConfig);
  }
}
